module.exports = __webpack_public_path__ + "img/decorate1.5d4fcc38.png";